export default {
  GET_DATA_SUCCESS(state, data) {
    state.printUrl = data.printUrl;
    state.title = data.title;
    state.pages = data.pages;
    state.ready = true;

    const defaultTranslations = state.translations;
    if (data.translations) {
      state.translations = data.translations;

      if (!state.translations.threesixtyOn) {
        state.translations.threesixtyOn = defaultTranslations.threesixtyOn;
      }

      if (!state.translations.threesixtyOff) {
        state.translations.threesixtyOff = defaultTranslations.threesixtyOff;
      }
    }

    if (data.alternativeLanguage) {
      document.body.classList.add(`font-${data.alternativeLanguage}`);
    }
  },
  GET_DATA_FAILED(state) {
    state.title = '';
    state.printUrl = '';
    state.pages = [];
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js